<template>
  <div class="date-range">
    <el-form-item :prop="startKey">
      <el-date-picker
        class="single-date"
        v-model="form[startKey]"
        type="month"
        :value-format="valueFormat"
        :picker-options="pickerOptions"
        placeholder="开始日期">
      </el-date-picker>
    </el-form-item>
    <span class="separator">至</span>
    <el-form-item :prop="endKey">
      <el-date-picker
        class="single-date"
        v-model="form[endKey]"
        type="month"
        :value-format="valueFormat"
        placeholder="结束日期"
        :picker-options="pickerOptions"
        @change="onEndDateChange">
      </el-date-picker>
    </el-form-item>  
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'FormMonthRange',
  props: {
    form: Object,
    startKey: String,
    endKey: String,
    // 是否使用时分秒
    usingTime: {
      type: Boolean,
      default: true
    },
    valueFormat: String,
    pickerOptions: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    onEndDateChange(val) {
      if (!this.usingTime || !this.valueFormat || !val) {
        return;
      }
      this.form[this.endKey] = moment(val).endOf('day').format('YYYY-MM HH:mm:ss');
    }
  }
}
</script>

<style lang="stylus" scoped>
.date-range
  display: flex
  align-items: center
  justify-content: space-between
  width 240px
  .el-form-item
    margin-bottom 0 !important
    margin-right 0 !important
  .separator
    flex 1
    text-align center
    font-size 12px
  .single-date
    width 110px !important
    >>>.el-input__prefix
      left 0
    >>>.el-input__suffix
      right 0
    >>>.el-input__inner
      padding 0 20px 0 25px
    >>>.el-form-item
      margin-bottom 0 !important
</style>